"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var proxiedIndexOf = function (arr, _, args) {
    var itemToFind = args[0];
    if (itemToFind && typeof itemToFind === 'object' && itemToFind._isProxy) {
        itemToFind = itemToFind.valueOf();
    }
    for (var i = 0, len = arr.length; i < len; i++) {
        var item = arr[i];
        if (item && typeof item === 'object' && item._isProxy) {
            item = item.valueOf();
        }
        if (item === itemToFind)
            return i;
    }
    return -1;
};
exports.default = proxiedIndexOf;
//# sourceMappingURL=proxiedIndexOf.js.map